import { type ThemeOptions, type Theme } from '@mui/material';

export function createPickerStyles() {
  return {
    MuiPickersPopper: {
      styleOverrides: {
        paper: ({ theme }: { theme: Theme }) => ({
          variants: [
            {
              // TypeScript workaround: Explicitly type props parameter to avoid TS7006 'Parameter implicitly has an any type'
              // The square prop is used to conditionally apply borderRadius
              props: (props: { square?: boolean }) => !props['square'],
              style: {
                borderRadius: `${theme.shape.borderRadiusMd}px`,
              },
            },
          ],
        }),
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        switchViewButton: {
          '&.Mui-focusVisible': {
            '&::after': {
              inset: 4, // override the default focus outline
            },
          },
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: ({ theme }: { theme: Theme }) => ({
          '&.Mui-focusVisible': {
            '&::after': {
              borderRadius: `${theme.ui.focus.borderRadius}`,
              content: '""',
              inset: 2,
              outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
              outlineOffset: `${theme.ui.focus.outlineOffset}`,
              position: 'absolute',
            },
          },
        }),
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        root: ({ theme }: { theme: Theme }) => ({
          '& .MuiPickersYear-yearButton': {
            '&:focus': {
              background: 'none',
              borderRadius: `${theme.ui.focus.borderRadius}`,
              outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
              outlineOffset: `${theme.ui.focus.outlineOffset}`,
            },
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
